import React from 'react';
import * as IoIcons from 'react-icons/io';
import * as RiIcons from 'react-icons/ri';


// Para TRANSPORTISTA
export const DataMenuTransp = [
  
  {
    title: 'Confirmados',
    path: 'confirmados',
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />
  }
];
